import React from 'react';
// import classNames from 'classnames';
import styles from './index.module.scss';

interface IProps {
  name: string;
  id: string | number;
  onClose: any;
}

export default function CloseTag({ name, id, onClose }: IProps) {
  return (
    <a className={styles.closeTag}>
      <span className={styles.text}>{name}</span>
      <svg className="icon" aria-hidden="true" onClick={() => onClose(id)}>
        <use xlinkHref="#icon-clear" />
      </svg>
    </a>
  );
}
